export { default } from './CompareDesktop';
